/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import Aufmacher from '../components/Microsites/Aufmacher';
import ModulAbholen from '../components/Microsites/Modules/ModulAbholen';
import ModulAccordion from '../components/Microsites/Modules/ModulAccordion';
import ModulAufforderung from '../components/Microsites/Modules/ModulAufforderung';
import ModulBildergalerie from '../components/Microsites/Modules/ModulBildergalerie';
import ModulInfoBildText2Spaltig from '../components/Microsites/Modules/ModulInfoBildText2Spaltig';
import ModulInfoBildText3Spaltig from '../components/Microsites/Modules/ModulInfoBildText3Spaltig';
import ModulInfoText1Spaltig from '../components/Microsites/Modules/ModulInfoText1Spaltig';
import ModulInfoText2Spaltig from '../components/Microsites/Modules/ModulInfoText2Spaltig';
import ModulInfoText3Spaltig from '../components/Microsites/Modules/ModulInfoText3Spaltig';
import ModulInfoVideo from '../components/Microsites/Modules/ModulInfoVideo';
import ModulProdukte from '../components/Microsites/Modules/ModulProdukte';
import ModulTestimonials from '../components/Microsites/Modules/ModulTestimonials';
import VORLAGE from '../components/VORLAGE';

const components = new Map();
components.set('Aufmacher', Aufmacher);
components.set('ModulAbholen', ModulAbholen);
components.set('ModulAccordion', ModulAccordion);
components.set('ModulAufforderung', ModulAufforderung);
components.set('ModulBildergalerie', ModulBildergalerie);
components.set('ModulInfoBildText2Spaltig', ModulInfoBildText2Spaltig);
components.set('ModulInfoBildText3Spaltig', ModulInfoBildText3Spaltig);
components.set('ModulInfoText1Spaltig', ModulInfoText1Spaltig);
components.set('ModulInfoText2Spaltig', ModulInfoText2Spaltig);
components.set('ModulInfoText3Spaltig', ModulInfoText3Spaltig);
components.set('ModulInfoVideo', ModulInfoVideo);
components.set('ModulProdukte', ModulProdukte);
components.set('ModulTestimonials', ModulTestimonials);
components.set('VORLAGE', VORLAGE);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
